/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Faq_Q1Inputs */

const en_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What focus time counts toward progress?`)
};

const ar_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما وقت التركيز الذي يُحتسب ضمن التقدم؟`)
};

const de_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Fokuszeit zählt zum Fortschritt?`)
};

const es_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tiempo de concentración cuenta para el progreso?`)
};

const fr_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel temps de concentration compte dans la progression ?`)
};

const it_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale tempo di concentrazione conta per i progressi?`)
};

const ja_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの集中時間が進捗にカウントされますか？`)
};

const ko_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 집중 시간이 진행도에 반영되나요?`)
};

const pt_br_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual tempo de foco conta para o progresso?`)
};

const ru_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какое время фокусировки засчитывается в прогресс?`)
};

const th_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาโฟกัสแบบไหนที่นับรวมในความคืบหน้า?`)
};

const tr_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hangi odaklanma süresi ilerlemeye sayılır?`)
};

const zh_cn_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哪些专注时间会计入我的进度？`)
};

const zh_tw_invite_page_faq_q1 = /** @type {(inputs: Invite_Page_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哪些專注時間會計入我的進度？`)
};

/**
* | output |
* | --- |
* | "What focus time counts toward progress?" |
*
* @param {Invite_Page_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_faq_q1 = /** @type {((inputs?: Invite_Page_Faq_Q1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Faq_Q1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_faq_q1(inputs)
	if (locale === "ar") return ar_invite_page_faq_q1(inputs)
	if (locale === "de") return de_invite_page_faq_q1(inputs)
	if (locale === "es") return es_invite_page_faq_q1(inputs)
	if (locale === "fr") return fr_invite_page_faq_q1(inputs)
	if (locale === "it") return it_invite_page_faq_q1(inputs)
	if (locale === "ja") return ja_invite_page_faq_q1(inputs)
	if (locale === "ko") return ko_invite_page_faq_q1(inputs)
	if (locale === "pt_br") return pt_br_invite_page_faq_q1(inputs)
	if (locale === "ru") return ru_invite_page_faq_q1(inputs)
	if (locale === "th") return th_invite_page_faq_q1(inputs)
	if (locale === "tr") return tr_invite_page_faq_q1(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_faq_q1(inputs)
	return zh_tw_invite_page_faq_q1(inputs)
});